<style lang="scss" scoped>
.site-list {
  .main-title {
    font-size: 2rem;
    margin: 0 0 1rem;
  }
  .new-site-form {
    label {
      font-size: 1.5rem;
      display: inline-block;
      margin: 0 0 0.5rem;
    }
    .input-group {
      display: flex;
      .form-control {
        flex: 1;
      }
    }
  }
  .recommend-site-list {
    display: flex;
  }
  .recommend-site-item {
    border: 1px solid #eee;
    border-radius: 5px;
    width: 260px;
    margin: 0 20px 20px 0;
    .thumb {
      border-bottom: 1px solid #eee;
      img {
        width: 100%;
      }
    }
    .site-item-content {
      padding: 10px;
      .recommend-site-title {
        font-size: 2rem;
        margin: 0 0 1rem;
        display: block;
      }
      .recommend-site-message {
        font-size: 1.5rem;
      }
      .actions {
        margin: 2rem 0 0;
      }
    }
  }
}
</style>

<template>
  <div class="site-list">
    <div class="container">
      <br />
      <div class="row">
        <div class="col-6">
          <div class="new-site-form">
            <div class="form-group">
              <label for="">サイト名</label>
              <input type="text" class="form-control" v-model="newSite.title" />
            </div>
            <div class="form-group">
              <label for="">URL</label>
              <input type="text" class="form-control" v-model="newSite.url" />
            </div>
            <div class="form-group">
              <label for="">サムネイル(ロゴ等)</label>
              <template v-if="thumbUrl">
                <img :src="thumbUrl" alt="" />
              </template>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="newSite.thumb_url"
                />
                <a href="#" class="btn btn-green" @click.prevent="checkThumb">
                  <template v-if="state.thumbChecking">チェック中...</template>
                  <template v-else>チェック</template>
                </a>
              </div>
            </div>
            <div class="form-group">
              <label for="">説明文</label>
              <textarea
                rows="4"
                class="form-control"
                v-model="newSite.description"
              ></textarea>
            </div>
            <div class="form-group">
              <a href="#" class="btn btn-green" @click.prevent="addSite"
                >追加</a
              >
            </div>
          </div>
        </div>
      </div>
      <h1 class="main-title">おすすめサイト一覧</h1>
      <div class="recommend-site-list">
        <div
          class="recommend-site-item"
          v-for="site in recommend_sites"
          :key="site.id"
        >
          <div class="thumb">
            <img :src="thumbUrlFor(site.thumb)" alt="" />
          </div>
          <div class="site-item-content">
            <a class="recommend-site-title" :href="site.url" target="_blank">{{
              site.title
            }}</a>
            <p class="recommend-site-message">{{ site.description }}</p>
            <div class="actions">
              <a href="#" class="btn btn-red" @click.prevent="deleteSite(site)"
                >削除</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    thumbUrl() {
      if (this.newSite.thumb.length) {
        return `https://res.cloudinary.com/macm/image/upload/w_150,h_100,c_pad/${this.newSite.thumb}.jpg`;
      }
    },
  },
  data() {
    const el = document.getElementById('site-list');
    const recommend_sites = JSON.parse(el.dataset.recommendSites);

    return {
      recommend_sites,
      newSite: {
        url: '',
        title: '',
        thumb: '',
        thumb_url: '',
        description: '',
      },
      state: {
        thumbChecking: false,
      },
    };
  },
  methods: {
    thumbUrlFor(id) {
      return `https://res.cloudinary.com/macm/image/upload/w_300,h_200,c_pad/${id}.jpg`;
    },
    checkThumb() {
      this.state.thumbChecking = true;
      $.ajax({
        url: '/api/image/upload',
        data: {
          url: this.newSite.thumb_url,
        },
        method: 'POST',
      })
        .then((response) => {
          this.newSite.thumb = response.public_id;
          this.state.thumbChecking = false;
        })
        .catch((e) => {
          alert('アップロードに失敗しました。');
          this.state.thumbChecking = false;
        });
    },
    addSite() {
      $.ajax({
        url: '/admins/recommend_sites',
        method: 'POST',
        data: {
          recommend_site: this.newSite,
        },
      })
        .then((response) => {
          this.recommend_sites.push(response);
        })
        .catch((e) => {
          alert('作成に失敗しました。');
        });
    },
    deleteSite(site) {
      $.ajax({
        url: `/admins/recommend_sites/${site.id}`,
        method: 'DELETE',
      })
        .then((response) => {
          const idx = this.recommend_sites.findIndex((s) => s.id === site.id);
          this.recommend_sites.splice(idx, 1);
        })
        .catch((e) => {
          alert('削除に失敗しました。');
        });
    },
  },
};
</script>
